import { Link } from "react-router-dom";
import { BrandWordmark } from "@/components/BrandWordmark";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black text-white mt-auto">
      <div className="container mx-auto px-6 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        {/* Brand column */}
        <div className="col-span-2 md:col-span-2 space-y-4">
          <Link to="/" className="inline-block">
            <BrandWordmark size="md" className="text-white" />
          </Link>
          <p className="text-xs text-white/60 max-w-xs leading-relaxed">
            Bracket challenges for every major soccer tournament. Free to play. Real prizes on the line.
          </p>
          <p className="text-[11px] text-white/40">
            © 2026 FCbracket.com · Made with ❤️ and crayons.
          </p>
        </div>

        {/* Play */}
        <div>
          <p className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-white/50 mb-3">Play</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/tournaments" className="text-white/80 hover:text-primary transition-colors">Tournaments</Link></li>
            <li><Link to="/lp/world-cup" className="text-white/80 hover:text-primary transition-colors">World Cup 2026</Link></li>
            <li><Link to="/pricing" className="text-white/80 hover:text-primary transition-colors">Pricing</Link></li>
            <li><Link to="/auth" className="text-white/80 hover:text-primary transition-colors">Sign up</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <p className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-white/50 mb-3">Company</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/our-story" className="text-white/80 hover:text-primary transition-colors">Our Story</Link></li>
            <li><Link to="/blog" className="text-white/80 hover:text-primary transition-colors">Blog</Link></li>
            <li><Link to="/affiliate" className="text-white/80 hover:text-primary transition-colors">Affiliate Program</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-primary transition-colors">Contact</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <p className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-white/50 mb-3">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="text-white/80 hover:text-primary transition-colors">Privacy</Link></li>
            <li><Link to="/terms" className="text-white/80 hover:text-primary transition-colors">Terms</Link></li>
            <li><Link to="/contest-rules" className="text-white/80 hover:text-primary transition-colors">Contest Rules</Link></li>
            <li><Link to="/unsubscribe" className="text-white/80 hover:text-primary transition-colors">Unsubscribe</Link></li>
          </ul>
        </div>
      </div>

      {/* Disclaimer strip */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 py-5">
          <p className="text-[11px] text-white/40 text-center leading-relaxed max-w-4xl mx-auto">
            FCBracket is not affiliated with, endorsed by, or connected to FIFA, UEFA, CONCACAF, CONMEBOL, MLS, or any football governing body.
            All tournament names and trademarks are the property of their respective owners and are used here for identification purposes only.
            Must be 18+ to enter paid contests. Void where prohibited.
          </p>
        </div>
      </div>
    </footer>
  );
}
